import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import { isEmpty } from "lodash";
import { usDateFormat } from "../../../../utils";

const PaymentDetails = ({
  paymentMethod,
  fieldValues,
  loanData,
  loanSettingInfo,
  today,
  calculateNetAmount,
  calculateTotalFees,
}) => {
  return (
    <div className="loan-page-scroll">
      <div
        className="mt-3 ml-3"
        style={{
          width: "80%",
          border: "1px solid #D1CFCF",
          borderRadius: "5px",
          padding: "20px 25px 20px 25px",
          marginBottom: "25px",
        }}
      >
        <div>
          <div
            style={{
              borderBottom: "0.5px dashed #BDBDBD",
              marginBottom: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  color: "#333333",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Requested Amount
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "#333333",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                ${fieldValues?.requestedAmount}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  color: "#777777",
                  fontWeight: "400",
                }}
              >
                TPA Fee{" "}
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "#333333",
                  fontWeight: "400",
                }}
              >
                ${fieldValues?.loanFeeAmount ?? 0}
              </p>
            </div>

            {paymentMethod == 1 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    color: "#777777",
                    fontWeight: "400",
                  }}
                >
                  Cheque fee
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#333333",
                    fontWeight: "400",
                  }}
                >
                  ${fieldValues.chequeFees ?? 0}
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    color: "#777777",
                    fontWeight: "400",
                  }}
                >
                  EFT fee
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#333333",
                    fontWeight: "400",
                  }}
                >
                  ${fieldValues.eftFees ?? 0}
                </p>
              </div>
            )}
          </div>
          <div
            className="disp-flex-col"
            style={{
              borderBottom: "0.5px dashed #BDBDBD",
              marginBottom: "15px",
            }}
          >
            <div
              className="disp-flex-row"
              style={{
                justifyContent: "space-between",
                marginBottom: "15px",
              }}
            >
              <p
                style={{
                  fontWeight: "500",
                  color: "#333333",
                  fontSize: "14px",
                  margin: "0px",
                }}
              >
                Total Fee amount
              </p>
              <p
                style={{
                  fontWeight: "500",
                  color: "#333333",
                  fontSize: "16px",
                  margin: "0px",
                }}
              >
                ${calculateTotalFees()}
              </p>
            </div>
            <div
              className="disp-flex-row "
              style={{
                justifyContent: "space-between",
                marginBottom: "15px",
              }}
            >
              <p
                style={{
                  fontWeight: "500",
                  color: "#333333",
                  fontSize: "14px",
                  margin: "0px",
                }}
              >
                Net Amount
              </p>
              <p
                style={{
                  fontWeight: "500",
                  color: "#333333",
                  fontSize: "16px",
                  margin: "0px",
                }}
              >
                ${calculateNetAmount()}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                fontWeight: "400",
                color: "#333333",
              }}
            >
              Date of Request :
              {usDateFormat(loanData?.loanRequestDate) ?? usDateFormat(today)}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "12px",
                fontWeight: "400",
                color: "#333333",
              }}
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              <p style={{ marginBottom: "0px", marginLeft: "5px" }}>
                Loan Processing time :{" "}
                {loanData?.loanSettingInfo?.processingTimeForLoan ??
                  loanSettingInfo?.processingTimeForLoan}{" "}
                Days
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="ml-3">
        <p className="ft-14 fw-500">Payment Method</p>
        {paymentMethod == 2
          ? (loanData?.bankInformationDetails ?? loanData?.eft) && (
              <div
                style={{
                  width: "80%",
                  border: "1px solid #D1CFCF",
                  borderRadius: "5px",
                  padding: "20px",
                  marginBottom: "25px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    marginBottom: "10px",
                  }}
                >
                  EFT ( Electronic fund transfer)
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "20px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#F5F5F5",
                    width: "100%",
                    height: "64px",
                    border: "1px solid #E8E8E8",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Account Holder
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData.bankInformationDetails?.accountHolderName ??
                        loanData?.eft?.accountHolderName}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Bank Name
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.bankInformationDetails
                        ?.nameOfTheFinancialInstitution ??
                        loanData?.eft?.nameOfFinancialInstitution}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Routing No
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.bankInformationDetails
                        ?.abaRoutingNumberforBankOfCreditUnion ??
                        loanData?.eft?.routingNumber}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Account No
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.bankInformationDetails
                        ?.checkingSavingsAccountNumber ??
                        loanData?.eft?.accountNumber}
                    </p>
                  </div>
                </div>
              </div>
            )
          : (loanData?.address ?? loanData?.cheque) && (
              <div
                style={{
                  width: "80%",
                  border: "1px solid #D1CFCF",
                  borderRadius: "5px",
                  padding: "20px",
                  marginBottom: "25px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    marginBottom: "10px",
                  }}
                >
                  Mail Cheque To Address
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "20px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#F5F5F5",
                    width: "100%",
                    height: "64px",
                    border: "1px solid #E8E8E8",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Cheque Payable To
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.address?.checkPayableTo ??
                        loanData?.cheque?.checkPayableTo}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Address
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.address?.address1 ??
                        loanData?.cheque?.address?.address1}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      City
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.address?.city ??
                        loanData?.cheque?.address?.city}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "##777777",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      Country
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333333",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {loanData?.cheque == undefined
                        ? loanData?.address?.country ??
                          loanData?.address?.foreignCountry
                        : loanData?.cheque?.address?.country ??
                          loanData?.cheque?.address?.foreignCountry}
                    </p>
                  </div>
                </div>
              </div>
            )}
      </div>
    </div>
  );
};

export default PaymentDetails;
